<div class="udex-grid udex-mx-auto udex-pt-56" role="alert">
  @if (!customerPortalError) {
    <dcp-loading-page/>
  } @else {
    <dcp-generic-configurator-error
      imgPath="../../../../assets/images/configurator/checkout_service_error.png"
      headline="configurator.error.somethingWrong">
    </dcp-generic-configurator-error>

    <p role="alert" class="text-grey text-center udex-mb-20">
      @if (customerPortalError.description) {
        <span
          [attr.data-cy]="'auto-bp-errorMessage'"
          [innerHTML]="customerPortalError.description">
        </span>
      } @else {
        <div [attr.data-cy]="'auto-bp-defaultMessage'">
          {{ 'configurator.error.contactUs.message' | cxTranslate }}
        </div>
      }

      @if (customerPortalError?.errorCode) {
        <span
          [attr.data-cy]="'auto-bp-errorCode'"
          class="text-blue-gray text-nowrap">
          {{ 'configurator.error.code' | cxTranslate:{errorCode: customerPortalError.errorCode} }}
          </span>
      }
    </p>

    <dcp-contact-us-button
      class="d-block udex-mx-auto"
      [errorMessage]="customerPortalError?.description">
    </dcp-contact-us-button>
  }
</div>
